<ion-toolbar mode="md" color="darkish-blue">
  <ion-item lines="none" mode="md" color="darkish-blue" class="item-total">
    <ion-icon
      color="white"
      slot="start"
      [src]="'Icons.cart-outline-white' | translate"
      class="icon-cart"
    ></ion-icon>

    <ion-label color="white" class="label-summary">
      <p class="total_precio">
        {{ summaryPrice.total_precio | currency }}
      </p>

      <p class="total_productos">
        {{ summaryPrice.total_cajas }}&nbsp;{{
          "Labels.boxes" | translate | lowercase
        }}
      </p>
    </ion-label>

    <ion-button
      expand="block"
      [size]="sizeButton"
      color="tpcta"
      slot="end"
      mode="md"
      class="ion-text-capitalize button-right"
      (click)="onBuy()"
      [disabled]="summaryPrice.total_cajas < 1"
    >
      {{ "Buttons.show-car" | translate }}
    </ion-button>
  </ion-item>
</ion-toolbar>
